import "reflect-metadata";
import { getAppConfig } from "../config";
import APIAgent, { HTTPClient } from "../generated/UserAPIAgent";
import { ReactHttpClient } from "./ReactHttpClient";

export let agent: APIAgent;
let client: HTTPClient;

export function initAgent(): void {
    const config = getAppConfig();
    if (!agent) {
        client = new ReactHttpClient(config.apiBaseUrl);
        agent = new APIAgent(client);
    }
}

export function setAccessToken(accessToken: string): void {
    client.setHeaders({ Authorization: "Bearer " + accessToken });
}
